import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight, ColoredChevronLeft } from "../../../../assets/icons";
import Button, { ButtonStyle } from "../../../../common/components/button/button";
import styles from "./payment.module.css";
import { useView } from "../provider/ViewContext";
import { useLazyGetOrderNextPaymentQuery } from "../../../../service/order-service";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader } from "../../../../stores/slices/loader-slice";
import { toast } from "react-toastify";
import RadioButtonLong from "../../../../common/components/radio/RadioButtonLong";
import { PAYMENT_CHOICE } from "../constant";
import ConfirmationDialog from "../../../../common/components/dialog/ConfirmationDialog";
import { formatDate } from "../../../../utils";

const Repayment = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { setView, updatePaymentInfo, updateNextPaymentInfo, resetContext, orderId, paymentInfo } = useView();
	const [getOrderDetails, { data }] = useLazyGetOrderNextPaymentQuery();
	const [showConfirm, setShowConfirm] = useState(false);

	useEffect(() => {
		if (orderId) {
			handleGetOrderDetails();
		}
	}, [orderId]);

	const handleGetOrderDetails = () => {
		dispatch(showLoader());
		getOrderDetails(orderId)
			.unwrap()
			.then(res => updateNextPaymentInfo(res))
			.catch(err => {
				toast.error(err?.data?.title as string);
				resetContext();
			})
			.finally(() => dispatch(hideLoader()));
	};

	const handleNext = () => {
		if (!paymentInfo) {
			toast.warning("Kindly select a payment choice");
			return;
		}
		setView("initialDeposit");
	};

	return (
		<>
			{showConfirm && (
				<ConfirmationDialog
					title="Are you sure you want to cancel payment?"
					description="Kindly confirm this action"
					actionLoading={false}
					onConfirm={() => {
						navigate("/customer/dashboard");
						setView("default");
						updatePaymentInfo(undefined);
					}}
					onCloseDialog={() => setShowConfirm(!showConfirm)}
					btnText="Proceed"
				/>
			)}
			<div className={styles.container}>
				<div className={styles.wrapper}>
					<div className={styles.header}>
						<Button rightIcon={<ColoredChevronLeft />} title="Cancel" style={ButtonStyle.WHITE} onClick={() => setShowConfirm(!showConfirm)} />
						<div className={styles.title}>
							{/* <div className={styles.titleHeader}>Congratulations!</div> */}
							{/* <span className={styles.subTitle}>Before you make a deposit please provide the following information for us</span> */}
						</div>
						<Button
							// disbaled={!canProceed}
							style={ButtonStyle.DARK}
							title="Confirm BNPL Payment"
							leftIcon={<ChevronRight />}
							onClick={handleNext}
						/>
					</div>
					<div className={`${styles.optionHeader} ${styles.repaymentHeader}`}>How much would you like to pay today?</div>
					<RadioButtonLong
						leftSection={
							<div className={styles.dueInfo}>
								<span>Amount Due</span>
								<span className={styles.date}>Due {formatDate(data?.dueDate)}</span>
							</div>
						}
						middleSection={<span>₦{data?.amount?.toLocaleString()}</span>}
						isSelected={paymentInfo?.paymentChoice === PAYMENT_CHOICE.NEXT_INSTALLMENT}
						onSelected={() => updatePaymentInfo({ paymentChoice: PAYMENT_CHOICE.NEXT_INSTALLMENT, amount: data?.amount ?? 0 })}
					/>
					<RadioButtonLong
						leftSection={<span>Full Package Amount</span>}
						middleSection={
							<div className={styles.repaymentAmount}>
								<span className={styles.cross}>₦{data?.totalAmount?.toLocaleString()}</span>
								<span>₦{data?.remainingAmount.toLocaleString()}</span>
							</div>
						}
						isSelected={paymentInfo?.paymentChoice === PAYMENT_CHOICE.BALANCE}
						onSelected={() => updatePaymentInfo({ paymentChoice: PAYMENT_CHOICE.BALANCE, amount: data?.remainingAmount ?? 0 })}
					/>

					<div className={styles.centerSection}>
						<div className={styles.centerSectionTitle}>NEXT PAYMENTS</div>
						<table className={styles.offerTable}>
							<tbody>
								{data?.installments?.map(({ amount, dueDate }, index) => (
									<tr key={index}>
										<td className={styles.property}>{formatDate(dueDate)}</td>
										<td className={styles.value}>
											{/* <span className={styles.date}>{dueDate}</span>  */}
											<span className={styles.divider}></span>₦{amount.toLocaleString()}
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
				<div className={styles.bottomControl}>
					<Button rightIcon={<ColoredChevronLeft />} title="Cancel" style={ButtonStyle.WHITE} onClick={() => setShowConfirm(true)} />
					<Button
						// disbaled={!canProceed}
						style={ButtonStyle.DARK}
						title="Confirm BNPL Payment"
						leftIcon={<ChevronRight />}
						onClick={handleNext}
					/>
				</div>
			</div>
		</>
	);
};
export default Repayment;
